export const isEmpty = (value: unknown): boolean => {
    return (
        value === null ||
        value === undefined ||
        (Array.isArray(value) && value.length === 0) ||
        value === '' ||
        Object.keys(value).length === 0
    );
};
